/* eslint-disable react/no-array-index-key */
import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import anime from "animejs";
import debounce from "lodash/debounce";

const NightSky = ({ starDensity = 5, shootingStarDensity = 1 }) => {
  const elementRef = useRef(null);
  const [vw, setVw] = useState(
    Math.max(
      document.documentElement.clientWidth,
      elementRef.current?.clientWidth || 0,
      window.innerWidth || 0,
    ),
  );
  const [vh, setVh] = useState(
    Math.max(
      document.documentElement.clientHeight,
      elementRef.current?.clientHeight || 0,
      window.innerHeight || 0,
    ),
  );

  const randomRadius = () => {
    return Math.random() * 0.8 + 0.6;
  };
  const getRandomX = () => {
    return Math.floor(Math.random() * Math.floor(vw));
  };
  const getRandomY = () => {
    return Math.floor(Math.random() * Math.floor(vh));
  };

  const handleResize = debounce(() => {
    setVw(
      Math.max(
        document.documentElement.clientWidth,
        elementRef.current?.clientWidth,
        window.innerWidth || 0,
      ),
    );
    setVh(
      Math.max(
        document.documentElement.clientHeight,
        elementRef.current?.clientHeight,
        window.innerHeight || 0,
      ),
    );
  }, 500);

  const starsForArea = Math.floor(((vw * vh) / 100) * (starDensity / 100));
  const shootingStarsForArea = Math.floor(
    ((vw * vh) / 100) * (shootingStarDensity / 100),
  );

  const starryNight = () => {
    anime({
      targets: ["#sky .star"],
      opacity: [
        {
          duration: 700,
          value: "0",
        },
        {
          duration: 700,
          value: "1",
        },
      ],
      easing: "linear",
      loop: true,
      delay: (el, i) => 50 * i,
    });
  };

  const shootingStars = () => {
    anime({
      targets: ["#shootingstars .wish"],
      easing: "linear",
      loop: true,
      delay: (el, i) => 1000 * i,
      opacity: [
        {
          duration: 700,
          value: "1",
        },
      ],
      width: [
        {
          value: 150,
        },
        {
          value: "0",
        },
      ],
      translateX: 350,
    });
  };

  useEffect(() => {
    starryNight();
    shootingStars();
  }, []);

  useLayoutEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      handleResize();
    }, 100);
  }, []);

  return (
    <>
      <svg id="sky" className="w-full h-full" ref={elementRef}>
        {[...Array(starsForArea)].map((x, y) => (
          <circle
            cx={getRandomX()}
            cy={getRandomY()}
            r={randomRadius()}
            stroke="none"
            strokeWidth="0"
            fill="#8a8a8a"
            key={y}
            className="star"
          />
        ))}
      </svg>
      <div id="shootingstars" className="w-full h-full">
        {[...Array(shootingStarsForArea)].map((x, y) => (
          <div
            key={y}
            className="wish"
            style={{
              left: getRandomY(),
              top: getRandomX(),
            }}
          />
        ))}
      </div>
    </>
  );
};

export default React.memo(NightSky);
